module.exports = __webpack_public_path__ + "static/media/comp.448bdebc.png";